interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}

export function Container({ children, className = '' }: ContainerProps) {
  return (
    <div className={`max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-8 ${className}`}>{children}</div>
  );
}
